/* GRIG Shopify theme JS — AJAX cart, free-ship progress, reveal, consent/tracking scaffold */
(function(){
  var $ = function(s,r){return (r||document).querySelector(s);};
  var FREE = Number(window.GRIG_FREE_SHIPPING);
  if (!Number.isFinite(FREE) || FREE < 0) FREE = 4900;
  // The cart before discounts counts when the store grants free shipping that way and every
  // applied code combines with it; otherwise the total after discounts.
  function shippingBase(c) {
    var ok = window.GRIG_SHIP_CODES;
    if (!Array.isArray(ok) || !Number.isFinite(c.original_total_price)) return c.total_price;
    var codes = (Array.isArray(c.discount_codes) ? c.discount_codes : []).filter(function (d) { return d && d.applicable !== false; });
    return codes.every(function (d) { return ok.indexOf(String(d.code).toUpperCase()) >= 0; }) ? c.original_total_price : c.total_price;
  }
  // The pickup app (Globe) prices its delivery options on the cart after discounts, while the
  // checkout grants free shipping before them (owner, 26 Oct 2026): a cart that reached free
  // shipping shows its options as free. Globe redraws its prices, so they are painted again
  // after every change, and its own price comes back once the cart falls under the threshold.
  var deliveryFree = null, FREE_WORD = ({cs:'Zdarma', de:'Kostenlos', fr:'Gratuit'})[String(document.documentElement.lang).slice(0, 2)] || 'Free';
  function paintDelivery() {
    if (deliveryFree === null) return;
    document.querySelectorAll('.globe-delivery-price').forEach(function (n) {
      if (deliveryFree) {
        // An empty price slot (no pickup point chosen yet) stays empty.
        if (n.textContent !== FREE_WORD && /\d/.test(n.textContent)) { n.dataset.grigPrice = n.textContent; n.textContent = FREE_WORD; }
        n.classList.add('grig-delivery-free');
      } else if (n.dataset.grigPrice != null) {
        if (n.textContent === FREE_WORD) n.textContent = n.dataset.grigPrice;
        delete n.dataset.grigPrice; n.classList.remove('grig-delivery-free');
      }
    });
  }
  function setDeliveryFree(free) { deliveryFree = free; paintDelivery(); }
  var deliveryFrame = 0;
  new MutationObserver(function () {
    if (deliveryFree === null || deliveryFrame) return;
    deliveryFrame = requestAnimationFrame(function () { deliveryFrame = 0; paintDelivery(); });
  }).observe(document.documentElement, {childList:true, subtree:true, characterData:true});
  // The language list opens at the foot of the phone menu: bring all of it into view.
  document.addEventListener('toggle', function (event) {
    var d = event.target;
    if (d && d.matches && d.matches('details.gmenu-lang') && d.open) d.scrollIntoView({block:'nearest', behavior:'smooth'});
  }, true);
  document.addEventListener('grig:cart-updated', function (event) {
    var c = event.detail && event.detail.cart;
    if (c && Number.isFinite(c.total_price)) setDeliveryFree(FREE > 0 && shippingBase(c) >= FREE);
  });
  (function () {
    var form = document.getElementById('cartForm'), base = form && Number(form.dataset.gcartShippingBase);
    if (form && form.dataset.gcartShippingBase && Number.isFinite(base)) setDeliveryFree(FREE > 0 && base >= FREE);
  })();
  var ROUTES = window.GRIG_ROUTES;
  var T = window.GRIG_I18N;
  var priceLocale = /^(de|fr|cs)(-|$)/i.test(document.documentElement.lang) ? document.documentElement.lang : 'en';
  var priceCurrency = window.GRIG_CURRENCY || 'EUR';
  var priceFormat = new Intl.NumberFormat(priceLocale, {
    style: 'currency', currency: priceCurrency,
    minimumFractionDigits: priceCurrency === 'CZK' ? 0 : 2, maximumFractionDigits: 2
  });

  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function money(cents){ return priceFormat.format(cents / 100); }

  // The drawer stays compact: unit prices are shown on the product page and in /cart.

  /* header shrink */
  var hdr = $('#hdr');
  addEventListener('scroll', function(){ if(hdr) hdr.classList.toggle('scrolled', scrollY>16); }, {passive:true});

  /* Reveals are progressively enhanced by grig-motion.js. */

  /* toast: a polite live region above every layer; hidden, it holds no text. A shown toast takes
     its own taps: a tap dismisses it, and while it goes (a moment after) it still takes a tap aimed
     at it, so no tap on it ever reaches a control it covered. */
  var toastNode = $('#toast'), toastText = $('#toastTxt'), tT;
  function hideToast(){
    if (!toastNode) return;
    clearTimeout(tT);
    if (toastNode.classList.contains('show')) toastNode.classList.add('is-leaving');
    toastNode.classList.remove('show');
    tT = setTimeout(function(){
      toastNode.classList.remove('is-leaving');
      if (!toastNode.classList.contains('show')) toastText.textContent = '';
    }, 400);
  }
  // Under an open modal dialog the page is inert and drawn beneath the top layer, so a toast there
  // would be neither seen nor read: while one is open (the upsell popup too) the toast lives inside
  // it (at its top) and goes back to the page when it closes. It moves before anything is told in
  // it, so its live region is read there.
  function toastHost(){
    var open = Array.prototype.filter.call(document.querySelectorAll('dialog[open]'), function(dialog){
      try { return dialog.matches(':modal'); } catch (error) { return true; }
    }).pop();
    return open || document.body;
  }
  function placeToast(){
    var host = toastNode && toastHost();
    if (host && toastNode.parentNode !== host) host.appendChild(toastNode);
  }
  if (toastNode && window.MutationObserver) new MutationObserver(placeToast).observe(document.body, {attributes:true, attributeFilter:['open'], subtree:true});
  function toast(m){
    if (!toastNode) return;
    // What the upsell popup's own accept does the popup tells itself (its status while it waits,
    // its alert when it fails, or the drawer it gives way to, which keeps the notice): no toast
    // repeats it in the popup.
    if (window.GRIGCartUpsell && window.GRIGCartUpsell.accepting && toastHost().id === 'grigUpsell') return;
    clearTimeout(tT);
    placeToast();
    toastText.textContent = m;
    toastNode.classList.remove('is-leaving'); toastNode.classList.add('show');
    tT = setTimeout(hideToast, 2200);
  }
  if (toastNode) toastNode.addEventListener('click', hideToast);

  /* cart drawer */
  var drawer = $('#drawer'), scrim = $('#scrim');
  var cartState = null, cartBusy = false, cartRevision = 0;
  var productCache = new Map();
  var localizedImages = {};
  try { localizedImages = JSON.parse(($('#grigCartImages') || {}).textContent || '{}') || {}; }
  catch (error) { localizedImages = {}; }
  var imageLang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  if (!/^(cs|de|fr)$/.test(imageLang)) imageLang = 'en';


  // A closed drawer is only moved off screen, so it is inert: nothing in it can take focus or
  // be pressed (a Space or Enter meant for the page never changes the cart). Focus is only ever
  // handed to something that changes nothing: opening the drawer moves it to the drawer's title;
  // Escape closes it; keyboard focus inside a drawer being closed goes to the cart button, never
  // back to what opened it (an add button would add again on a held or repeated key, or a later
  // Space) and never into the closed drawer.
  // The open drawer is modal: the page it covers is inert, drawn by grig-a11y.js (GRIGLayers),
  // the one place that tells the overlay layers apart (the cookie preferences, the mobile menu,
  // a dialog, the drawer). Only one is open at a time: the drawer never opens under another one
  // (openCart answers false); an add that lands meanwhile is told by the count, a toast and its
  // live region instead.
  function layers(){ return window.GRIGLayers || null; }
  function otherLayer(){ var open = layers() && layers().open; return !!open && open !== 'drawer'; }
  function focusQuietly(node){ if (node) { try { node.focus({preventScroll:true}); } catch (error) { /* Focus is a courtesy. */ } } }
  // A target inside the drawer's scrolling body is also scrolled into its visible part, now and
  // once more when the drawer is next drawn (its footer grows and shrinks with the cart).
  function focusInView(node){
    if (!node) return;
    function show(){ if (document.activeElement === node) { try { node.scrollIntoView({block:'nearest', inline:'nearest'}); } catch (error) { /* Focus is a courtesy. */ } } }
    focusQuietly(node); show(); requestAnimationFrame(show);
  }
  // pointer: closed with the mouse or a tap. Keyboard focus inside the drawer then goes to the
  // page body (nothing is focused, nothing shows a ring it lacks); closed from the keyboard it
  // goes to the cart button, which shows its ring.
  function openCart(o, pointer){
    var opening = !!o && !!drawer && !drawer.classList.contains('open');
    if (opening && otherLayer()) return false;
    var inside = !!drawer && !o && drawer.contains(document.activeElement);
    if (drawer && !o) lostFocus = null;
    if (inside && pointer) document.activeElement.blur();
    if (drawer) { drawer.classList.toggle('open', o); drawer.inert = !o; }
    if (scrim) scrim.classList.toggle('open', o);
    if (layers()) layers().sync();
    if (inside && !pointer) focusQuietly($('#cartBtn'));
    if (opening) focusQuietly($('#drTitle'));
    if (o) hideToast();
    // Surfaces drop whatever an expired catalog priced before the drawer shows it.
    if (opening) document.dispatchEvent(new CustomEvent('grig:cart-open'));
    return true;
  }
  var loadErrorShown = false;
  function cartError(message){
    var el = $('#drError');
    loadErrorShown = false;
    if (el) { el.textContent = message; el.hidden = !message; el.classList.remove('is-notice'); }
    if (message && (!drawer || !drawer.classList.contains('open'))) toast(message);
  }
  // A notice a surface already shows on screen, in its live region next to the control it holds
  // (the PDP step's wait), is not toasted as well: the shopper reads it once. It counts only where
  // it is drawn: the point in the middle of its part in the viewport is the notice, not the sticky
  // header over it or an open dialog (or its backdrop) above it.
  function shownOnScreen(message){
    return Array.prototype.some.call(document.querySelectorAll('[role="status"],[role="alert"],[aria-live]'), function(node){
      if (node.closest('#toast,[hidden],[inert]') || node.textContent.trim() !== message) return false;
      var r = node.getBoundingClientRect();
      var left = Math.max(r.left, 0), right = Math.min(r.right, innerWidth), top = Math.max(r.top, 0), bottom = Math.min(r.bottom, innerHeight);
      if (!(right > left && bottom > top)) return false;
      var hit = document.elementFromPoint((left + right) / 2, (top + bottom) / 2);
      return !!hit && node.contains(hit);
    });
  }
  // How a write whose outcome was unknown ended, read from the cart Shopify answered: a
  // neutral notice, neither a failure nor a success.
  function cartNotice(message){
    var el = $('#drError');
    loadErrorShown = false;
    if (!message) return;
    if (el) { el.textContent = message; el.hidden = false; el.classList.add('is-notice'); }
    if ((!drawer || !drawer.classList.contains('open')) && !shownOnScreen(message)) toast(message);
    // A page about to render the cart again (/cart) carries the notice across.
    document.dispatchEvent(new CustomEvent('grig:cart-notice', {detail:{message:message}}));
  }
  // An add or change whose answer never came may still be applied by Shopify: neither a
  // failure nor a success yet. The wait notice next to the held controls says, once, that the
  // cart is being checked (neutral); outside the open drawer a short toast says it only where no
  // notice on screen says it already (the /cart wait notice, the PDP step's).
  function cartChecking(){
    waitNotice();
    if (T.checking && (!drawer || !drawer.classList.contains('open')) && !shownOnScreen(T.checking)) toast(T.checking);
  }
  async function cartJSON(url, options, observe){
    var sent = Date.now(), response = await fetch(url, options || {headers:{Accept:'application/json'}, cache:'no-store'});
    if (observe) observe(response, sent, Date.now());
    if (!response.ok) throw new Error(T.updateError);
    return response.json();
  }
  // Shopify's clock, from the Date header of each answered cart read (whole seconds): Shopify
  // read it at some moment between sending and receiving, so each read bounds the offset of
  // the client clock. Only a read Shopify answered (response.ok) counts, only a prompt one (the
  // bounds at most 10 s apart) and only one within a day of the client clock; the tightest
  // bounds all such reads allow are kept (a read that contradicts them, the client clock set
  // meanwhile, starts them again). A client clock outside them is set to the latest Shopify time
  // they allow, so a Black Friday boundary is passed at or before Shopify's own, never after it
  // (a clock behind Shopify's would otherwise keep Black Friday copy on screen after Shopify
  // ended it). A client clock that agrees with them is left as it is.
  // A read more than a day off (a client clock set wrong by days, or one bad header) is believed
  // only once a second answered read agrees with it: their bounds overlap.
  var clockOffset = 0, clockBounds = null, clockCandidate = null, clockSampled = false, CLOCK_MAX_WIDTH = 10000, CLOCK_MAX_SKEW = 864e5;
  function clockAgree(a, b){ return !!a && !!b && a.lower <= b.upper && a.upper >= b.lower; }
  function sampleClock(response, sent, received){
    if (!response || !response.ok) return;
    // An answered read: the period Shopify's clock is in may be set from now on.
    clockSampled = true;
    var header = response.headers && response.headers.get('Date'), server = header ? Date.parse(header) : NaN;
    if (!Number.isFinite(server) || received < sent) return;
    var sample = {lower:server - received, upper:server + 999 - sent};
    if (sample.upper - sample.lower > CLOCK_MAX_WIDTH) return;
    if (Math.abs(server - received) > CLOCK_MAX_SKEW && !clockAgree(sample, clockBounds)) {
      if (!clockAgree(sample, clockCandidate)) { clockCandidate = sample; return; }
      sample = {lower:Math.max(sample.lower, clockCandidate.lower), upper:Math.min(sample.upper, clockCandidate.upper)};
      clockBounds = null;
    }
    clockCandidate = null;
    if (clockAgree(sample, clockBounds)) {
      clockBounds = {lower:Math.max(sample.lower, clockBounds.lower), upper:Math.min(sample.upper, clockBounds.upper)};
    } else clockBounds = sample;
    if (clockOffset < clockBounds.lower || clockOffset > clockBounds.upper) clockOffset = clockBounds.upper;
  }
  function serverNow(){ return Date.now() + clockOffset; }
  // A cart request that does not answer within 8 s is given up. A read fails like any
  // other read, so nothing priced for the last known cart outlives an unanswered read-back;
  // an add or change fails and the cart is read back through the normal path (Shopify may
  // have applied it), so the cart is never left busy.
  // A request given up this way is marked (code 'timeout', write for a POST): Shopify may
  // still apply an add or change it received, so its outcome is unknown, not a failure.
  var CART_TIMEOUT = 8000;
  async function cartRequest(url, options, observe){
    var controller = window.AbortController ? new AbortController() : null, timedOut = false;
    var timer = controller ? setTimeout(function(){ timedOut = true; controller.abort(); }, CART_TIMEOUT) : 0;
    try { return await cartJSON(url, Object.assign({}, options, controller ? {signal:controller.signal} : {}), observe); }
    catch (error) {
      if (!timedOut) throw error;
      var timeout = new Error('timeout');
      timeout.code = 'timeout'; timeout.write = !!(options && options.method === 'POST');
      throw timeout;
    }
    finally { clearTimeout(timer); }
  }
  async function getCart(){
    // A cart with bundle lines is read with their component evidence (grig-merchandising.js).
    // When the last cart had such lines, the evidence is fetched alongside the cart instead of
    // after it; a cart that turns out to have none drops it, and evidence for another cart than
    // the one read is not merged (it checks every line's key, variant and quantity).
    var merch = window.GRIGMerch, early = merch && merch.cartEvidence && cartState && Array.isArray(cartState.items) &&
      cartState.items.some(function(line){ return line.has_components === true; }) ? merch.cartEvidence() : null;
    var cart = await cartRequest(ROUTES.cart + '.js', {headers:{Accept:'application/json'}, cache:'no-store'}, sampleClock);
    // The session may have moved to another market since this page was drawn (the Czech shop in
    // another tab): the cart then comes in CZK while the page prices in euros. The page moves the
    // session back to its own country, Shopify reprices the cart, and it is read again. Once per
    // read: a refused move leaves the cart as Shopify gives it.
    if (cart && cart.currency && priceCurrency && cart.currency !== priceCurrency && window.GRIG_COUNTRY) {
      try {
        await fetch('/localization', {method:'POST', credentials:'same-origin',
          body:new URLSearchParams({form_type:'localization', _method:'put', country_code:window.GRIG_COUNTRY})});
        cart = await cartRequest(ROUTES.cart + '.js', {headers:{Accept:'application/json'}, cache:'no-store'}, sampleClock);
      } catch (_) {}
    }
    return merch && merch.enrichCart ? merch.enrichCart(cart, early) : cart;
  }
  function postCart(route, data){
    return cartRequest(route + '.js', {
      method:'POST', headers:{Accept:'application/json', 'Content-Type':'application/json'},
      body:JSON.stringify(data)
    });
  }
  // Keyboard focus on a drawer line control that is disabled (a change in flight) or drawn
  // again (a read showing another cart) goes back to the same control of the same line (its
  // key and what it does) as soon as that can take it, unless focus moved on meanwhile. It goes
  // back only into an open drawer, and only while it is lost (on the page body) or still on that
  // disabled control. A line the cart no longer holds never hands focus to a control of another
  // line (a held or repeated key, or a later Space, would change that line too): focus goes to
  // the title of the line now in its place (or the last line), which changes nothing, and an
  // emptied cart hands it to the drawer's title (the close button would close the drawer on the
  // next repeat, and what lies behind it could change the cart).
  var lostFocus = null, LOST_FOCUS_MS = 10000;
  function focusedControl(){
    var items = $('#ditems'), active = document.activeElement;
    if (!items || !active || active === document.body || !items.contains(active)) return null;
    var line = active.closest('[data-dr-key]');
    return {key:line ? line.dataset.drKey : null, index:Array.prototype.indexOf.call(items.querySelectorAll('[data-dr-key]'), line),
      label:active.dataset.gmuLabel || null, action:active.dataset.gdrAction || null, at:Date.now()};
  }
  function restoreFocus(){
    var items = $('#ditems'), control = lostFocus, active = document.activeElement;
    if (!control || !items) return;
    var open = !!drawer && drawer.classList.contains('open');
    if (!open || (active && active !== document.body && !(items.contains(active) && active.disabled)) || Date.now() - control.at > LOST_FOCUS_MS) { lostFocus = null; return; }
    function same(button){ return control.label ? button.dataset.gmuLabel === control.label : button.dataset.gdrAction === control.action; }
    var lines = items.querySelectorAll('[data-dr-key]'), target = null;
    var line = Array.prototype.find.call(lines, function(node){ return node.dataset.drKey === control.key; });
    if (line) target = Array.prototype.find.call(line.querySelectorAll('button'), same);
    else if (!cartPending() && cartState) {
      var next = lines[Math.min(Math.max(control.index, 0), lines.length - 1)];
      target = next ? next.querySelector('.dr-title') : $('#drTitle');
    }
    if (!target || target.disabled) return;
    lostFocus = null;
    focusInView(target);
  }
  // Checkout and the quantity controls act on the cart drawn here: they stay off while no read
  // confirms it (a change in flight, a write that may still land, a period boundary) and come
  // back with the read that does, or when the bounded wait releases the cart read last.
  // A wait that holds the cart (no read confirms it, or a change unanswered for about 2 s) is
  // told in the drawer: a short neutral notice for as long as it lasts.
  function waitNotice(){
    var node = $('#drWait'), copy = waitCopy();
    if (!node) return;
    if (node.textContent !== copy) node.textContent = copy;
    node.hidden = !copy;
  }
  function cartControls(){
    waitNotice();
    if (!drawer) return;
    var pending = cartPending();
    // Only the lines are busy for assistive technology: the wait notice (a live region) stays
    // outside them. The drawer's own class hides whatever it priced for the cart being replaced.
    if ($('#ditems')) $('#ditems').setAttribute('aria-busy', String(pending));
    drawer.classList.toggle('is-pending', pending);
    var held = pending || !cartState, focused = focusedControl();
    if (focused && held) lostFocus = focused;
    drawer.querySelectorAll('[data-dr-change]').forEach(function(b){ b.disabled = held; });
    restoreFocus();
    // The drawer's one CTA leads to /cart (the delivery choice is made only there); it is held
    // like checkout while a change runs or no read confirms the cart, and off for an empty cart.
    var continueLink = $('#drContinue');
    var inactive = held || cartBusy || !cartState.item_count;
    if (continueLink) {
      continueLink.setAttribute('aria-disabled', String(inactive));
      if (inactive) continueLink.removeAttribute('href');
      else continueLink.setAttribute('href', ROUTES.cart);
    }
  }
  function quantityButton(item, quantity, label, symbol, className){
    return '<button type="button" class="' + (className || 'dr-qty-button') + '" data-dr-change="' + esc(item.key) +
      '" data-quantity="' + quantity + '" data-gmu-label="' + label + '">' + symbol + '</button>';
  }
  // Every drawer surface that states the shipping progress of one cart: bar, copy, runner, icons.
  function drawShipping(progress, unlocked, copy){
    if ($('#shipBar')) $('#shipBar').style.transform = 'scaleX(' + progress + ')';
    if ($('#shipTxt')) $('#shipTxt').textContent = copy;
    var runner = $('#gmRunner');
    if (runner) {
      runner.style.transform = 'translateX(' + (progress * 100) + '%)';
      var pose = $('img', runner), source = unlocked ? pose.dataset.cheer : pose.dataset.run;
      if (pose.getAttribute('src') !== source) { pose.hidden = false; pose.dataset.gmSrc = source; }
      else delete pose.dataset.gmSrc;
    }
    document.dispatchEvent(new Event('grig:art'));
    if ($('#gmShipTruck')) $('#gmShipTruck').hidden = unlocked;
    if ($('#gmShipSparkle')) $('#gmShipSparkle').hidden = !unlocked;
  }
  // Nothing priced or decided for a cart the drawer cannot vouch for stays: line prices
  // (struck ones included), the total and every shipping surface. Lines and their count
  // stay only for a cart that was actually read (c).
  function voidCartClaims(c){
    if (drawer) drawer.querySelectorAll('.dr-item .dr-price').forEach(function(price){
      // The lines drawn last no longer show what they were drawn with.
      if (price.firstChild) { price.replaceChildren(); drawnItems = null; }
    });
    if ($('#dtot')) $('#dtot').textContent = '\u2026';
    if ($('#cnt')) $('#cnt').textContent = c ? c.item_count : '\u2026';
    drawShipping(0, false, '');
  }
  // The markup of the drawer lines as drawn last: a read showing the same cart (a window
  // regaining focus, another window's broadcast, a re-read) draws nothing again, so the control
  // keyboard focus is on stays where it is.
  var drawnItems = null;
  function itemsMarkup(c, claims){
    return c.items.map(function(i){
      var image = localizedImages[i.variant_id] || (i.image && (typeof i.image === 'string' ? i.image : i.image.src)) ||
        (i.featured_image && i.featured_image.url);
      var final = i.final_line_price == null ? i.line_price : i.final_line_price;
      var original = i.original_line_price == null ? final : i.original_line_price;
      // Struck price only when Shopify itself reports a lower final line price.
      var was = Number.isFinite(original) && Number.isFinite(final) && final < original ? '<s class="dr-was">' + esc(money(original)) + '</s>' : '';
      return '<div class="dr-item" data-dr-key="' + esc(i.key) + '" data-dr-variant="' + esc(i.variant_id) + '"><a class="dr-image" href="' + esc(i.url) + '" tabindex="-1" aria-hidden="true">' +
        (image ? '<img src="' + esc(image) +
          '" alt="' + esc(i.product_title) + '" width="64" height="64" loading="eager" decoding="async">' : '') +
        '</a><div class="dr-details"><span class="dr-title" tabindex="-1"><a class="dr-link" href="' + esc(i.url) + '">' + esc(String(i.product_title || '').replace(/ (g)$/i, '\u00a0$1')) + '</a></span>' +
        (i.variant_title && i.variant_title !== 'Default Title' ? '<small class="dr-variant">' + esc(i.variant_title) + '</small>' : '') +
        '</div><div class="dr-price">' + (claims ? was + '<span class="p">' + esc(money(final)) + '</span>' : '') + '</div>' +
        '<div class="dr-actions"><div class="dr-quantity">' + quantityButton(i, i.quantity - 1, 'decrease', '−') +
        '<span>' + i.quantity + '</span>' + quantityButton(i, i.quantity + 1, 'increase', '+') + '</div>' +
        quantityButton(i, 0, 'remove', '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
          '<path d="M3 6h18M9 6V4h6v2M5 6l1 14h12l1-14M10 10v6M14 10v6"/></svg>', 'dr-remove') +
        '</div><div class="dr-extra" data-dr-extra></div></div>';
    }).join('');
  }
  function renderCart(c){
    cartState = c;
    // A read that does not confirm what the cart must show now is drawn without a claim from
    // the start: no line price, total or shipping state of it is ever put on screen.
    var claims = !unconfirmed();
    if ($('#cnt')) $('#cnt').textContent = c.item_count;
    if ($('#dtot')) $('#dtot').textContent = claims ? money(c.total_price) : '\u2026';
    var items = $('#ditems'), markup = items ? itemsMarkup(c, claims) : null;
    if (items && markup !== drawnItems) {
      lostFocus = focusedControl() || lostFocus;
      items.innerHTML = markup; drawnItems = markup;
      items.querySelectorAll('[data-gmu-label]').forEach(function(button){
        var item = c.items.find(function(i){ return i.key === button.dataset.drChange; });
        button.setAttribute('aria-label', T[button.dataset.gmuLabel] + ' ' + item.product_title);
      });
      if (!c.items.length) {
        var empty = $('#gmEmptyCart');
        if (empty) items.append(empty.content.cloneNode(true));
        else {
          var message = document.createElement('div');
          message.className = 'dempty'; message.textContent = T.empty; items.append(message);
        }
      }
    }
    if ($('.ship', drawer)) $('.ship', drawer).hidden = !['EUR', 'CZK'].includes(priceCurrency);
    // Free shipping counts the cart before discounts, as checkout does (owner, 26 Oct 2026).
    var shipBase = shippingBase(c);
    var progress = FREE === 0 ? 1 : Math.max(0, Math.min(shipBase / FREE, 1));
    if (claims) drawShipping(progress, shipBase >= FREE, shipBase >= FREE ? T.freeship :
      T.shipmore.replace('{amount}', money(FREE - shipBase)));
    else drawShipping(0, false, '');
    cartControls();
    // Line decorations (box upgrade, summary) re-attach after every render.
    document.dispatchEvent(new CustomEvent('grig:cart-rendered', {detail:{cart:c}}));
    // Whatever a listener drew, an unconfirmed cart keeps no claim; then focus goes back.
    if (!claims) voidCartClaims(c);
    restoreFocus();
  }
  function productURL(handle){
    return ROUTES.root.replace(/\/+$/, '') + '/products/' + encodeURIComponent(handle) + '.js';
  }
  function loadProduct(handle){
    if (!productCache.has(handle)) productCache.set(handle, cartJSON(productURL(handle)).catch(function(){
      productCache.delete(handle);
      return null;
    }));
    return productCache.get(handle);
  }
  function imageSlug(title){
    return String(title || 'Default Title').toLowerCase().replace(/ & /g, '-').replace(/ /g, '-');
  }
  function imageMarkers(variant, localizedTitle){
    var names = [variant && variant.title, localizedTitle];
    var english = {'chili':'chilli','piment':'chilli','käse':'cheese','fromage':'cheese','sýr':'cheese',
      'salz':'salt','sel':'salt','sůl':'salt','speck':'bacon','slanina':'bacon',
      'chili-limette':'chilli-lime','piment-et-citron-vert':'chilli-lime',
      'knoblauch':'garlic','ail':'garlic','česnek':'garlic','meersalz':'sea-salt',
      'sel-marin':'sea-salt','mořská-sůl':'sea-salt'};
    var markers = [];
    names.forEach(function(name){
      var slug = imageSlug(name), mapped = english[slug] || slug;
      markers.push('[var:' + slug + ']', '[var:' + mapped + ']');
    });
    return markers;
  }
  function chooseCartImage(product, variant, width, localizedTitle){
    if (!product) return '';
    var media = Array.isArray(product.media) ? product.media : [];
    var markers = imageMarkers(variant, localizedTitle), chosen = null, rank = 99;
    media.forEach(function(m){
      if (!m || (m.media_type && m.media_type !== 'image')) return;
      var alt = String(m.alt || '').toLowerCase();
      if (alt.includes('[hide:' + imageLang + ']') || alt.includes('on white') || alt.includes('white background')) return;
      var local = alt.includes('[lang:' + imageLang + ']'), english = alt.includes('[lang:en]');
      if (!local && !english) return;
      var hasVariant = alt.includes('[var:');
      var matchesVariant = markers.some(function(marker){ return alt.includes(marker); });
      if (hasVariant && !matchesVariant) return;
      var mediaSource = m.src || (m.preview_image && m.preview_image.src) || m.url;
      if (!mediaSource) return;
      var packshot = alt.includes('packshot');
      var score = local
        ? (matchesVariant ? (packshot ? 0 : 1) : (packshot ? 2 : 6))
        : (matchesVariant ? (packshot ? 3 : 4) : (packshot ? 5 : 7));
      if (score < rank) { chosen = mediaSource; rank = score; }
    });
    var featured = product.featured_image;
    var source = chosen || (typeof featured === 'string' ? featured : featured && (featured.src || featured.url));
    if (!source) return '';
    try {
      var url = new URL(source, window.location.href);
      if (url.protocol !== 'https:') return '';
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (error) { return ''; }
  }
  async function localizeCartImages(c){
    var changed = await Promise.all((c.items || []).map(async function(item){
      if (!item || localizedImages[item.variant_id] || !item.handle) return false;
      var product = await loadProduct(item.handle);
      var variant = product && Array.isArray(product.variants) && product.variants.find(function(v){
        return v && String(v.id) === String(item.variant_id);
      });
      var image = chooseCartImage(product, variant, 144, item.variant_title);
      if (!image) return false;
      localizedImages[item.variant_id] = image;
      return true;
    }));
    return changed.some(Boolean);
  }
  // Some moments change the cart Shopify holds without any change of ours: at a Black Friday
  // boundary its automatic discount starts or stops, but a client clock ahead of Shopify's
  // reads the cart before it does. Such a moment sets what a read must show (a test); until a
  // read does, the cart is pending: drawn without prices, total or shipping claims and read
  // again (1, 3, 10, 30, 60 s).
  // An add or change given up after 8 s (write timeout) sets the same kind of test: the
  // cart shows the change. Its read-backs are pending until one does, for a few seconds
  // (2, 5 s).
  // Every such wait is bounded: after the last re-read the cart read last stands as Shopify
  // answered it (its own line prices and totals are what Shopify charges, and checkout is on
  // again). What the test was to confirm is still claimed only where that read shows it (a
  // Black Friday tier or saving only with Shopify's own allocation), never assumed.
  var CONFIRM_DELAYS = [1000, 3000, 10000, 30000, 60000], WRITE_CONFIRM_DELAYS = [2000, 5000];
  var expectations = [];
  function unconfirmed(){ return expectations.length > 0; }
  function cartPending(){ return cartBusy || unconfirmed(); }
  // Waiting: the cart is held for longer than a moment (an expectation, or a change in flight
  // for over WAIT_NOTICE_MS); every surface holding controls off tells the shopper why.
  var busyLong = false, busyTimer = 0, WAIT_NOTICE_MS = 2000;
  function waiting(){ return !!cartState && (unconfirmed() || (cartBusy && busyLong)); }
  // What such a wait is about, in one notice: whether a change landed (one unanswered for over
  // WAIT_NOTICE_MS, or one that may still land) or the prices of a cart no read has confirmed
  // (a period boundary). Empty while nothing holds the cart for long.
  function waitCopy(){
    if (!waiting()) return '';
    return (writeUnknown() || (cartBusy && busyLong) ? T.checking : T.verifying) || '';
  }
  // An add or change may still land: another tap could add the same goods twice.
  function writeUnknown(){ return expectations.some(function(current){ return current.write; }); }
  function pendingEvent(){ document.dispatchEvent(new CustomEvent('grig:cart-pending', {detail:{pending:cartPending(), waiting:waiting(), wait:waitCopy()}})); }
  // An expectation ends in one of two ways, each told to its owner with the cart read then:
  // confirmed (a read showed it) or released (the backoff ran out first).
  function expectCart(test, options){
    if (typeof test !== 'function') return null;
    options = options || {};
    var current = {test:test, step:0, timer:0, delays:options.delays || CONFIRM_DELAYS,
      write:options.write === true, confirmed:options.confirmed || null, released:options.released || null};
    expectations.push(current);
    if (cartState && !cartBusy) renderCart(cartState);
    pendingEvent();
    confirmRead(current);
    return current;
  }
  function endExpectation(current){
    var index = expectations.indexOf(current);
    if (index < 0) return false;
    expectations.splice(index, 1); clearTimeout(current.timer);
    return true;
  }
  function settle(current, outcome, c){
    var callback = current[outcome];
    if (callback) { try { callback(c); } catch (error) { /* A notice cannot hold the cart. */ } }
  }
  function confirmRead(current){
    if (expectations.indexOf(current) < 0) return;
    // A pending change reads the cart back itself; the schedule goes on after it.
    (cartBusy ? Promise.resolve() : window.refreshCart()).catch(function(){}).then(function(){
      if (expectations.indexOf(current) < 0) return;
      if (current.step < current.delays.length) {
        current.timer = setTimeout(function(){ confirmRead(current); }, current.delays[current.step++]);
        return;
      }
      // Nothing showed it within the backoff: the cart read last stands and is drawn as it is.
      if (endExpectation(current)) {
        if (cartState && !cartBusy) renderCart(cartState);
        pendingEvent();
        settle(current, 'released', cartState);
      }
    });
  }
  // A read that shows what the cart must show ends that expectation.
  function confirms(c){
    return expectations.slice().filter(function(current){
      var shown = false;
      try { shown = current.test(c) === true; } catch (error) { shown = false; }
      return shown && endExpectation(current);
    });
  }
  // local: what a change made here did, for its own read-back (see lateArrival).
  async function refreshCart(local){
    var revision = ++cartRevision;
    var c;
    try { c = await getCart(); }
    catch (error) { if (revision !== cartRevision) return cartState; throw error; }
    if (revision !== cartRevision) return c;
    // A read succeeded: the notice of an earlier failed read is over.
    if (loadErrorShown) cartError('');
    var confirmed = confirms(c);
    // A late add is judged on this read before it is drawn, never on a read that confirmed
    // something or came while a write may still land (it could be that write); such a read still
    // moves the watch by the shopper's own change it carries (lateRebase). A change made here
    // that failed or whose outcome is unknown ends the watch.
    var arrived = false, boxLanded = lateSwapArrival(c);
    if (local && (local.unknown || local.failed)) lateAdd = null;
    else if (!confirmed.length && !writeUnknown()) arrived = lateArrival(c, local);
    else lateRebase(local);
    renderCart(c);
    if (confirmed.length) pendingEvent();
    localizeCartImages(c).then(function(changed){
      if (changed && revision === cartRevision) renderCart(c);
    }).catch(function(){ /* Optional image localization must not block the cart. */ });
    document.dispatchEvent(new CustomEvent('grig:cart-updated', {detail:{cart:c}}));
    // Owners act once every surface holds the cart that confirmed them.
    confirmed.forEach(function(current){ settle(current, 'confirmed', c); });
    if (arrived) cartNotice(T.lateAdded);
    if (boxLanded) cartNotice(T.lateSwap);
    return c;
  }
  // A box swap whose new box may still land (Shopify received the add but never answered): the
  // same exchange is neither offered nor posted again for a while, since a second one could
  // leave two new boxes, in any tab of this browser. The hold starts the moment that add is
  // given up (8 s), while the swap and its wait for the late box still run here, and lasts a
  // while after that wait is released. The holds are kept in localStorage with the time each
  // ends and read again at every check (and inside the cart lock, right before a swap is
  // posted), so another tab, or this page back from the back-forward cache, sees them as they
  // are now; another tab's change of them draws every surface again. Where localStorage cannot
  // be used they last for this page.
  // A read that shows that box (the line carrying the swap's own token, so nothing else can be
  // taken for it) ends the hold: quietly while the swap that made it still waits for it on this
  // page (it tells how it ended itself), with a short neutral note once that wait was released or
  // when another page made the hold (one left while its swap waited, this tab before a reload,
  // another tab: no swap here tells it); the end of the while ends it with nothing to say.
  var SWAP_HOLD_KEY = 'grig_swap_hold_v1', swapHolds = [], swapHoldsShared = true, swapHoldTimer = 0;
  // This page, told apart from every other one (another tab, this tab before or after a reload).
  var PAGE_ID = Date.now().toString(36) + Math.random().toString(36).slice(2);
  // A hold lasts its minute from when it was made. One stored as ending further off than that (the
  // client clock was set back since it was made) ends a minute from now at the latest.
  function loadSwapHolds(){
    if (!swapHoldsShared) return;
    try {
      var stored = JSON.parse(localStorage.getItem(SWAP_HOLD_KEY) || '[]');
      swapHolds = (Array.isArray(stored) ? stored : []).filter(function(hold){
        return hold && typeof hold.token === 'string' && /^\d{1,20}$/.test(String(hold.source)) && /^\d{1,20}$/.test(String(hold.target)) && Number.isFinite(hold.until);
      });
    } catch (error) { swapHoldsShared = false; return; }
    var latest = Date.now() + LATE_ADD_MS, clamped = false;
    swapHolds.forEach(function(hold){ if (hold.until > latest) { hold.until = latest; clamped = true; } });
    if (clamped) saveSwapHolds();
  }
  function saveSwapHolds(){
    if (!swapHoldsShared) return;
    try { localStorage.setItem(SWAP_HOLD_KEY, JSON.stringify(swapHolds)); } catch (error) { swapHoldsShared = false; }
  }
  // The holds still running; the end of the next one draws every surface again.
  function liveSwapHolds(){
    loadSwapHolds();
    var now = Date.now(), count = swapHolds.length;
    swapHolds = swapHolds.filter(function(hold){ return hold.until > now; });
    if (swapHolds.length !== count) saveSwapHolds();
    clearTimeout(swapHoldTimer);
    if (swapHolds.length) {
      var next = Math.min.apply(null, swapHolds.map(function(hold){ return hold.until; }));
      swapHoldTimer = setTimeout(function(){ liveSwapHolds(); pendingEvent(); }, next - now + 50);
    }
    return swapHolds;
  }
  // released: the swap's own wait for its box is over (a box that shows now is noted).
  function holdSwap(spec, released){
    loadSwapHolds();
    swapHolds = swapHolds.filter(function(hold){ return hold.token !== spec.token; });
    swapHolds.push({token:spec.token, source:String(spec.sourceVariantId), target:String(spec.targetVariantId), until:Date.now() + LATE_ADD_MS, released:!!released, page:PAGE_ID});
    saveSwapHolds(); liveSwapHolds(); pendingEvent();
  }
  // The swap's own read showed its box: its hold ends quietly.
  function dropSwapHold(token){
    loadSwapHolds();
    var count = swapHolds.length;
    swapHolds = swapHolds.filter(function(hold){ return hold.token !== token; });
    if (swapHolds.length !== count) { saveSwapHolds(); liveSwapHolds(); pendingEvent(); }
  }
  function swapHeld(source, target){
    return liveSwapHolds().some(function(hold){ return hold.source === String(source) && hold.target === String(target); });
  }
  addEventListener('storage', function(event){
    if (event.key !== SWAP_HOLD_KEY && event.key !== null) return;
    liveSwapHolds(); pendingEvent();
  });
  function lateSwapArrival(c){
    loadSwapHolds();
    var items = c && c.items || [], count = swapHolds.length, noted = false;
    swapHolds = swapHolds.filter(function(hold){
      var shown = items.some(function(line){ return !!line.properties && line.properties._grig_swap === hold.token; });
      if (shown && (hold.released || hold.page !== PAGE_ID)) noted = true;
      return !shown;
    });
    if (swapHolds.length === count) return false;
    saveSwapHolds(); liveSwapHolds();
    return noted;
  }
  // An add released as not in the cart may still be applied by Shopify later. For a while a
  // read that shows exactly it (the quantities read at the release plus the add) gives a short
  // neutral note, once: no added feedback, no drawer, no measurement, since a read cannot tell it
  // from the same goods added elsewhere. The watch ends at once whenever it could mistake
  // something else for it: another window's change (its broadcast), a read showing any other
  // line changed, a change made here that touched these goods, that failed, whose outcome is
  // unknown or that was not read back, a failed read. The read-back of the shopper's own add here
  // counts that add too, so a late add Shopify applied just before it is noted, never absorbed,
  // and the shopper's own add is never taken for the late one. Nothing watched, nothing noted.
  var lateAdd = null, LATE_ADD_MS = 60000;
  function heldOf(c, keys){ return keys.reduce(function(held, key){ held[key] = quantityOf(c, key); return held; }, {}); }
  function otherLines(c, keys){
    return (c && c.items || []).filter(function(line){ return keys.indexOf(String(line.variant_id || line.id)) < 0; })
      .map(function(line){ return line.key + ':' + line.quantity; }).join('|');
  }
  function watchLate(c, wanted){
    var keys = Object.keys(wanted || {});
    lateAdd = keys.length ? {wanted:wanted, before:heldOf(c, keys), others:otherLines(c, keys), until:Date.now() + LATE_ADD_MS} : null;
  }
  // The shopper's own change carried by a read that is not judged: the watch moves by what that
  // change added (a change of these goods that adds nothing ends it); what the read shows is
  // never taken as the new baseline, since it is not judged.
  function lateRebase(local){
    var watch = lateAdd;
    if (!watch || !local || local.changed !== true) return;
    var keys = Object.keys(watch.wanted), added = local.added || {}, before = {};
    if (!local.added && !(Array.isArray(local.touched) && local.touched.every(function(id){ return keys.indexOf(String(id)) < 0; }))) { lateAdd = null; return; }
    keys.forEach(function(key){ before[key] = watch.before[key] + (added[key] || 0); });
    lateAdd = {wanted:watch.wanted, before:before, others:watch.others, until:watch.until};
  }
  // local (the read-back of a change made here): changed with what it added (added) or which
  // goods it touched (touched); failed when it applied nothing.
  function lateArrival(c, local){
    var watch = lateAdd;
    lateAdd = null;
    if (!watch || Date.now() > watch.until || !c || !Array.isArray(c.items)) return false;
    var keys = Object.keys(watch.wanted), own = !!local && local.changed === true, added = own && local.added || {};
    if (!keys.length) return false;
    if (own && !local.added && !(Array.isArray(local.touched) && local.touched.every(function(id){ return keys.indexOf(String(id)) < 0; }))) return false;
    var held = heldOf(c, keys), others = otherLines(c, keys);
    if (!own && others !== watch.others) return false;
    function shows(late){ return keys.every(function(key){ return held[key] === watch.before[key] + (added[key] || 0) + (late ? watch.wanted[key] : 0); }); }
    if (shows(true)) return true;
    // Not there yet: watched on this read (the shopper's own change included).
    if (shows(false)) lateAdd = {wanted:watch.wanted, before:held, others:others, until:watch.until};
    return false;
  }
  function cartBusyEvent(){
    document.dispatchEvent(new CustomEvent('grig:cart-busy', {detail:{busy:cartBusy}}));
  }
  // The cart could not be read back: whatever was decided or priced for the last known
  // cart is void (voidCartClaims: line prices with struck ones, total, count and every
  // shipping surface) and checkout stays disabled until a read succeeds and renderCart
  // draws Shopify's cart again.
  function cartLoadFailed(){
    cartState = null; lateAdd = null;
    voidCartClaims();
    cartControls(); cartError(T.loadError); loadErrorShown = true;
    document.dispatchEvent(new CustomEvent('grig:cart-load-error'));
  }
  var cartChannel = null;
  try { cartChannel = window.BroadcastChannel ? new BroadcastChannel('grig-cart') : null; } catch (error) { cartChannel = null; }
  function announceChange(){
    if (cartChannel) { try { cartChannel.postMessage({type:'cart-changed'}); } catch (error) { /* Other windows read on focus. */ } }
  }
  function never(){ return false; }
  // applied: what a read shows once this write landed; outcome: what its owner does when a
  // write given up after 8 s shows after all (confirmed) and what the shopper reads when it
  // never showed within the backoff (released returns the notice); effect: what it changes,
  // the quantities it adds (added) or the goods it touches (touched), for its own read-back.
  async function mutateCart(action, errorMessage, applied, outcome, effect){
    if (cartBusy) return {ok:false, busy:true, cart:cartState};
    // An earlier add or change may still land: another write now could add the same goods
    // twice or set a quantity on a cart about to change. Every write (the product form, a
    // one-click add on any surface, a quantity change, a box swap) passes here, so none is
    // posted until that outcome is known; the shopper reads that the cart is being checked.
    if (writeUnknown()) { cartChecking(); return {ok:false, cart:cartState, reason:'write_unknown', unknown:true}; }
    cartBusy = true;
    ++cartRevision;
    busyLong = false; clearTimeout(busyTimer);
    busyTimer = setTimeout(function(){ if (!cartBusy) return; busyLong = true; cartControls(); pendingEvent(); }, WAIT_NOTICE_MS);
    // Until the read-back lands nothing of the cart being replaced is claimed: its line
    // prices, total, count and every shipping surface go together.
    voidCartClaims();
    cartError(''); cartControls(); cartBusyEvent();
    // landed: a write given up after 8 s that the mutation's own read-back already showed (its
    // owner was told as for any add); its caller reports no error after that.
    // reviewTold: a swap left in review whose step may still land; GRIGCart tells how it ended
    // (the wait, then one notice), so the surface that started it says nothing more.
    var ok = false, payload = null, reason = null, unknown = false, landed = false, reviewTold = false;
    async function execute(){
      try { payload = await action(); ok = true; }
      catch (error) {
        reason = error.code || 'request_failed';
        // An add or change Shopify received but never answered may still be applied: the
        // shopper reads that the cart is being checked, its read-backs are pending until one
        // shows the change (or a few seconds pass) and no failure is claimed.
        if (reason === 'timeout' && error.write === true) {
          unknown = true;
          expectCart(typeof applied === 'function' ? applied : never, {delays:WRITE_CONFIRM_DELAYS, write:true,
            confirmed:function(c){ landed = true; if (outcome && outcome.confirmed) outcome.confirmed(c); },
            // The cart Shopify answered last stands; the shopper reads what it shows. A failed
            // read already said so (cartLoadFailed).
            released:function(c){ if (c) cartNotice(outcome && outcome.released ? outcome.released(c) : T.reviewCart); }});
          cartChecking();
        }
        // A swap whose outcome could not be confirmed is reported by its surface as a review,
        // never as a failure the cart may contradict. When one of its steps was given up after
        // 8 s, that step may still land: the cart is read again on the same short backoff
        // (pending, no price or total) so a late step is shown, and no other write is posted
        // meanwhile.
        else if (reason === 'swap_review') {
          // It ends like a timed out add: the wait notice goes, and when nothing showed the
          // step the shopper reviews the cart Shopify answered last.
          var late = outcome && typeof outcome.lateStep === 'function' ? outcome.lateStep() : null;
          // The wait notice tells it while it lasts; how it ended is told once: a step that showed
          // leaves the cart for the shopper to review, as does one that never did.
          if (typeof late === 'function') reviewTold = !!expectCart(late, {delays:WRITE_CONFIRM_DELAYS, write:true,
            confirmed:function(c){ if (c && T.swapReview) cartNotice(T.swapReview); },
            // Never an invitation to try again: the step may still land after this.
            released:function(c){ var notice = outcome.released ? outcome.released(c) : T.reviewCart; if (c) cartNotice(notice); }});
        }
        // A box exchange another tab held while this one waited for the cart lock.
        else if (reason === 'swap_held') cartNotice(T.swapRelease);
        else cartError(errorMessage);
      }
      finally {
        var local = unknown || reason === 'swap_review' ? {unknown:true} : ok ? Object.assign({changed:true}, effect) : {failed:true};
        try { await refreshCart(local); }
        catch (error) { cartLoadFailed(); }
      }
    }
    try {
      if (navigator.locks && navigator.locks.request) await navigator.locks.request('grig-cart-mutation', execute);
      else await execute();
    } finally {
      cartBusy = false;
      clearTimeout(busyTimer);
      var waited = busyLong; busyLong = false;
      cartControls(); cartBusyEvent(); announceChange();
      if (waited) pendingEvent();
    }
    return {ok:ok, payload:payload, cart:cartState, reason:reason, unknown:unknown, landed:landed, reviewTold:reviewTold};
  }

  // "Added: <what Shopify answered it added>", for an add told without the drawer.
  function addedCopy(payload){
    var names = (payload && Array.isArray(payload.items) ? payload.items : []).map(function(line){
      var title = line && (line.product_title || line.title);
      return title ? title + (line.variant_title && line.variant_title !== 'Default Title' && line.product_title ? ' · ' + line.variant_title : '') : '';
    }).filter(Boolean);
    return names.length ? T.added + ' ' + names.join(', ') : T.grig_added;
  }
  function notifyAdded(payload, requested, options){
    if (window.trackAddToCartItems) {
      try { window.trackAddToCartItems(payload, requested, options.source || 'product'); }
      catch (error) { /* Measurement cannot interrupt the successful addition. */ }
    }
    // The usual confirmation of an addition: crunch, thumbs and the drawer.
    function feedback(){
      if (window.GRIG) {
        var motionTarget = options.button && options.button.isConnected ? options.button : $('#cartBtn');
        GRIG.crunch(motionTarget); GRIG.thumbs(T.grig_added);
      }
      if (options.openDrawer !== false && !openCart(true) && !(yieldSource() && openCart(true))) toast(addedCopy(payload));
    }
    // The dialog the add came from (a hotspot sheet, say) gives way to the drawer, so the drawer
    // replaces it instead of the add being told by a toast; any other open layer keeps the toast.
    function yieldSource(){
      var dialog = options.button && options.button.isConnected && options.button.closest ? options.button.closest('dialog[open]') : null;
      if (!dialog) return false;
      dialog.dispatchEvent(new CustomEvent('grig:yield-to-cart'));
      if (dialog.open) dialog.close();
      return !dialog.open;
    }
    // A one-time upsell may run first; it opens the drawer itself when it closes,
    // so a popup and the drawer are never on screen together. A decision that waits
    // (for a fresh catalog) gives the usual feedback itself when no popup follows. An add
    // a later read showed (its answer never came) gets the feedback, never a popup.
    var deferred = false;
    if (options.openDrawer !== false && !options.late && window.GRIGCartUpsell && typeof window.GRIGCartUpsell.afterAdd === 'function') {
      try {
        deferred = window.GRIGCartUpsell.afterAdd({items:requested, payload:payload, form:options.form || null,
          button:options.button || null, source:options.source || 'product', feedback:feedback}) === true;
      } catch (error) { deferred = false; }
    }
    if (!deferred) feedback();
    document.dispatchEvent(new CustomEvent('grig:cart-added', {
      detail:{form:options.form || null, items:requested, source:options.source || 'product'}
    }));
  }
  function notifyAddError(options, result){
    document.dispatchEvent(new CustomEvent('grig:cart-error', {
      detail:{form:options.form || null, source:options.source || 'product', reason:result && result.reason, unknown:!!(result && result.unknown)}
    }));
  }
  // What a cart shows once an add or change landed: an add, exactly the quantities held
  // before it plus those requested; a change, the line at its new quantity (or gone).
  function quantityOf(c, variantId){
    return (c && c.items || []).reduce(function(sum, line){
      return String(line.variant_id || line.id) === String(variantId) ? sum + Number(line.quantity || 0) : sum;
    }, 0);
  }
  // The quantities before are those of a cart Shopify answered: the one read last, re-based
  // on the read made inside the mutation lock right before the add is posted when there is
  // one. Without such a read nothing can show the add: it is never assumed. A cart that holds
  // more than the add would give (another window added too) does not show it either.
  function addShows(items){
    var wanted = {}, before = null;
    (items || []).forEach(function(item){ var key = String(item.id); wanted[key] = (wanted[key] || 0) + Number(item.quantity || 1); });
    var keys = Object.keys(wanted);
    function shows(c){ return !!before && keys.length > 0 && keys.every(function(key){ return quantityOf(c, key) === before[key] + wanted[key]; }); }
    shows.rebase = function(c){
      before = c && Array.isArray(c.items) ? keys.reduce(function(held, key){ held[key] = quantityOf(c, key); return held; }, {}) : null;
    };
    // Does the cart hold more of any requested item than before (or any, without a baseline)?
    shows.grew = function(c){ return keys.some(function(key){ return quantityOf(c, key) > (before ? before[key] : 0); }); };
    shows.wanted = wanted;
    shows.rebase(cartState);
    return shows;
  }
  // A timed out add that a read of its wait shows gets the usual feedback once (drawer, thumbs,
  // measurement); one that never shows leaves the shopper a neutral notice: none of it is in
  // the cart right now, check the cart before adding it again (a late add would make two), or
  // (the cart holds some of it) review the cart. One not in the cart is still watched for a
  // while (lateAdd), for a neutral note only.
  function addOutcome(requested, options, shows){
    function lines(c){
      var ids = requested.map(function(item){ return String(item.id); });
      return (c && c.items || []).filter(function(line){ return ids.indexOf(String(line.variant_id || line.id)) >= 0; });
    }
    return {
      confirmed:function(c){ notifyAdded({items:lines(c)}, requested, Object.assign({}, options, {late:true})); },
      released:function(c){
        if (shows.grew(c)) return T.reviewCart;
        watchLate(c, shows.wanted);
        return T.notAdded;
      }
    };
  }
  function propertyKey(properties){
    properties = properties || {};
    return JSON.stringify(Object.keys(properties).sort().map(function(key){ return [key, properties[key]]; }));
  }
  // What a cart shows once a swap step given up after 8 s landed after all: for the add, the
  // new box line carrying this swap's token; for the rollback of that add, no such line; for
  // the decrement, the source box quantity changed.
  function swapShows(spec, step){
    function variant(line, id){ return String(line.variant_id || line.id) === String(id); }
    function added(line){ return variant(line, spec.targetVariantId) && !!line.properties && line.properties._grig_swap === spec.token; }
    return function(c){
      var items = c && c.items || [];
      if (step === 'add') return items.some(added);
      if (step === 'rollback') return !!c && Array.isArray(c.items) && !items.some(added);
      return items.reduce(function(sum, line){
        return variant(line, spec.sourceVariantId) && propertyKey(line.properties) === propertyKey(spec.sourceProperties) ? sum + Number(line.quantity || 0) : sum;
      }, 0) !== spec.sourceQuantity;
    };
  }
  function changeShows(key, quantity){
    return function(c){
      var line = (c && c.items || []).find(function(item){ return item.key === key; });
      return quantity === 0 ? !line : !!line && line.quantity === quantity;
    };
  }
  window.GRIGCart = {
    get state(){ return cartState; },
    get busy(){ return cartBusy; },
    // Pending: a change is in flight or no read has confirmed what the cart must show now.
    get pending(){ return cartPending(); },
    // An add or change given up after 8 s may still land: no surface may post another.
    get writeUnknown(){ return writeUnknown(); },
    // Why the cart is held for longer than a moment, for the notice next to a held control.
    get wait(){ return waitCopy(); },
    // A box exchange released while its new box may still land: not offered again for a while.
    swapHeld:swapHeld,
    // Shopify's clock as the cart reads tell it: the time every Black Friday decision uses.
    now:serverNow,
    // Has a cart read been answered (so now() is as good as the reads make it)?
    get clockSampled(){ return clockSampled; },
    expect:function(test){ expectCart(test); },
    get open(){ return !!(drawer && drawer.classList.contains('open')); },
    openDrawer:function(open){ openCart(open !== false); },
    addItems:async function(items, options){
      options = options || {};
      if (!Array.isArray(items) || !items.length || items.some(function(item){
        return !Number.isSafeInteger(Number(item.id)) || Number(item.id) <= 0 ||
          !Number.isInteger(Number(item.quantity)) || Number(item.quantity) <= 0;
      })) return {ok:false, cart:cartState};
      var shows = addShows(items);
      var result = await mutateCart(async function(){
        if (options.validate) { var latest = await getCart(); shows.rebase(latest); await options.validate(latest); }
        return postCart(ROUTES.add, {items:items});
      }, T.err, shows, addOutcome(items, options, shows), {added:shows.wanted});
      if (result.ok) notifyAdded(result.payload, items, options);
      else if (!result.landed) notifyAddError(options,result);
      return result;
    },
    swapBox:async function(spec, options){
      options = options || {};
      if (!window.GRIGMerch || !window.crypto || !crypto.randomUUID) return {ok:false,cart:cartState,reason:'swap_changed'};
      spec = Object.assign({},spec,{token:'grig-v1-'+crypto.randomUUID()});
      // The same exchange released while its new box may still land is not posted again.
      if (swapHeld(spec.sourceVariantId, spec.targetVariantId)) {
        cartNotice(T.swapRelease);
        var held = {ok:false, cart:cartState, reason:'write_unknown', unknown:true};
        notifyAddError(options, held);
        return held;
      }
      // The step given up after 8 s that no later read of the swap has shown: it may still land
      // after the swap is reviewed. A read of the swap that shows it resolves it, so a step that
      // already landed sets no wait. A change of the line carrying this swap's token (in the
      // swap's last read) is the rollback of the new box, a step of its own.
      var unresolved = null, unresolvedKind = null, lastRead = null, boxShows = swapShows(spec, 'add'), holding = false;
      // A new box given up after 8 s may still land: every tab holds this exchange from now on.
      function step(kind, request){ return request.catch(function(error){
        if (error && error.code === 'timeout') {
          unresolved = swapShows(spec, kind); unresolvedKind = kind;
          if (kind === 'add') { holdSwap(spec, false); holding = true; }
        }
        throw error;
      }); }
      function seen(c){
        if (unresolved && unresolved(c)) unresolved = null;
        if (holding && boxShows(c)) { holding = false; dropSwapHold(spec.token); }
      }
      function rollsBack(key){
        var line = lastRead && Array.isArray(lastRead.items) && lastRead.items.find(function(item){ return item.key === key; });
        return !!line && !!line.properties && line.properties._grig_swap === spec.token;
      }
      var result = await mutateCart(function(){
        // Another tab may have held the same exchange while this one waited for the cart.
        if (swapHeld(spec.sourceVariantId, spec.targetVariantId)) { var heldError = new Error('swap_held'); heldError.code = 'swap_held'; return Promise.reject(heldError); }
        return GRIGMerch.swapTransaction(spec, {
          read:function(){ return getCart().then(function(c){ lastRead = c; seen(c); return c; }); },
          add:function(items){return step('add', postCart(ROUTES.add,{items:items}));},
          change:function(key,quantity){return step(rollsBack(key) ? 'rollback' : 'change', postCart(ROUTES.change,{id:key,quantity:quantity}));}
        },options.validate);
      },T.updateError,null,{lateStep:function(){ return unresolved; },
        // Released with its new box still able to land: the same exchange is held for a while.
        released:function(){ if (unresolved && unresolvedKind === 'add') { holdSwap(spec, true); return T.swapRelease; } return T.swapReview; }},
        {touched:[spec.sourceVariantId, spec.targetVariantId]});
      // Refused inside the lock: told as a held exchange, the outcome another tab waits for.
      if (result.reason === 'swap_held') result = Object.assign({}, result, {reason:'write_unknown', unknown:true});
      if(result.ok)notifyAdded(result.payload,[{id:spec.targetVariantId,quantity:1}],options);
      else notifyAddError(options,result);
      return result;
    },
    change:async function(key, quantity){
      if (!key || !Number.isInteger(quantity) || quantity < 0) return {ok:false,cart:cartState};
      var line = cartState && cartState.items.find(function(item){ return item.key === key; });
      return mutateCart(function(){ return postCart(ROUTES.change, {id:key,quantity:quantity}); },T.updateError,changeShows(key, quantity), null,
        {touched:line ? [line.variant_id || line.id] : null});
    }
  };
  if (drawer) drawer.addEventListener('click', function(e){
    var change = e.target.closest('[data-dr-change]');
    if (cartBusy || !change) return;
    window.GRIGCart.change(change.dataset.drChange, Number(change.dataset.quantity));
  });
  // A read nobody waits on (page load, the cart button, a return to the tab, a Black Friday
  // boundary) that fails is tried once more, after a short delay or as soon as the browser
  // is back online, before anything fails closed: a phone waking up often loses its first
  // request. Meanwhile nothing new is decided; only a failed retry voids the cart and tells
  // the shopper. A change or a newer read started in between decides instead.
  var CART_RETRY_DELAY = 1500;
  window.refreshCart = function(){
    // A pending change reads the cart back itself; a read now (the cart button, a return to
    // the tab, a boundary) would draw the cart it is replacing over its pending marking.
    if (cartBusy) return Promise.resolve(cartState);
    return refreshCart().catch(function(){
      var revision = cartRevision;
      return new Promise(function(resolve){
        var timer = setTimeout(done, CART_RETRY_DELAY);
        function done(){ clearTimeout(timer); removeEventListener('online', done); resolve(); }
        addEventListener('online', done);
      }).then(function(){
        if (cartBusy || revision !== cartRevision) return cartState;
        return refreshCart();
      }).catch(cartLoadFailed);
    });
  };
  // A cart that could not be read is read again once the browser is back online.
  addEventListener('online', function(){ if (!cartBusy && !cartState) window.refreshCart(); });
  if ($('#cartBtn')) $('#cartBtn').onclick = function(){ openCart(true); window.refreshCart(); };
  // The cart may have changed in another tab, or this page may come back from the
  // back-forward cache: read it again, so nothing stays decided for an old cart. A
  // pending change reads the cart back itself.
  document.addEventListener('visibilitychange', function(){
    if (document.visibilityState === 'visible' && !cartBusy) window.refreshCart();
  });
  addEventListener('pageshow', function(event){ if (event.persisted && !cartBusy) window.refreshCart(); });
  // Two windows side by side are both visible, so neither sees a visibilitychange when the
  // other changes the cart. A window that gains focus reads it again (at most every 2 s), and
  // each change made here tells the other windows of this shop to read it (BroadcastChannel).
  var FOCUS_READ_GAP = 2000, focusReadAt = -Infinity;
  addEventListener('focus', function(){
    if (cartBusy || Date.now() - focusReadAt < FOCUS_READ_GAP) return;
    focusReadAt = Date.now(); window.refreshCart();
  });
  if (cartChannel) cartChannel.addEventListener('message', function(event){
    if (!event.data || event.data.type !== 'cart-changed') return;
    // Another window changed the cart: a late add here can no longer be told from its change.
    lateAdd = null;
    if (!cartBusy) window.refreshCart();
  });
  // A click with a pointer has a click count (detail); one from Enter or Space has none.
  if ($('#closeCart')) $('#closeCart').onclick = function(event){ openCart(false, !!event && event.detail > 0); };
  document.addEventListener('keydown', function(event){
    if (event.key === 'Escape' && !event.defaultPrevented && drawer && drawer.classList.contains('open')) openCart(false);
  });
  if (scrim) scrim.onclick = function(){ openCart(false, true); };
  /* AJAX add to cart */
  document.addEventListener('submit', function(e){
    var f = e.target.closest('form[data-grig-add]');
    if (!f) return;
    e.preventDefault();
    // A second tap while the popup decision for the last addition waits adds nothing. Nor
    // does one while an earlier add or change may still land: mutateCart refuses it.
    if (cartBusy || (window.GRIGCartUpsell && window.GRIGCartUpsell.pending)) return;
    var fd = new FormData(f);
    var submitButton = e.submitter || f.querySelector('button[type="submit"]');
    var requested = window.GRIGMerch ? GRIGMerch.requestedItems(fd) : [];
    var options = {form:f,button:submitButton,source:f.dataset.grigSource || 'product'}, shows = addShows(requested);
    // The tapped button shows at once that the add runs (a spinner, its size kept) until it ends.
    function adding(on){ if (!submitButton) return; submitButton.classList.toggle('grig-adding', on); if (on) submitButton.setAttribute('aria-busy','true'); else submitButton.removeAttribute('aria-busy'); }
    adding(true);
    mutateCart(async function(){
      if (typeof f.grigValidate === 'function') { var latest = await getCart(); shows.rebase(latest); await f.grigValidate(latest); }
      return cartRequest(ROUTES.add + '.js', {method:'POST', headers:{Accept:'application/json'}, body:fd});
    }, T.err, shows, addOutcome(requested, options, shows), {added:shows.wanted}).then(function(result){
      adding(false);
      if (result.ok) notifyAdded(result.payload, requested, options);
      // An add its own read-back showed was announced as added: no error follows it.
      else if (!result.landed) notifyAddError(options,result);
    }, function(){ adding(false); });
  });

  window.refreshCart();

  /* ===== Souhlas s cookies: kategorie + Consent Mode v2 + Shopify Customer Privacy API ===== */
  window.dataLayer = window.dataLayer || [];
  window.gtag = function(){ dataLayer.push(arguments); };
  var IDS = window.GRIG_IDS || {};
  var CUR = window.GRIG_CURRENCY || 'EUR';
  var KEY = 'grig_consent_v2';
  var MAXAGE = 365 * 864e5;   /* souhlas se po roce znovu zeptá */

  gtag('consent','default',{ad_storage:'denied',analytics_storage:'denied',
    ad_user_data:'denied',ad_personalization:'denied',functionality_storage:'granted',
    security_storage:'granted'});

  function set(v){ return v && String(v).indexOf('XXX') === -1 && String(v).trim() !== ''; }

  function loadAnalytics(marketing){
    var clarityID = String(window.GRIG_CLARITY_ID || '').trim();
    if (/^[a-z0-9]+$/i.test(clarityID)) {
      if (!window.__grigClarity) {
        window.__grigClarity = true;
        window.clarity = window.clarity || function(){
          (window.clarity.q = window.clarity.q || []).push(arguments);
        };
        var clarityScript = document.createElement('script');
        clarityScript.defer = true;
        clarityScript.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(clarityID);
        window.clarity('consent');
        document.head.appendChild(clarityScript);
      }
      window.clarity('consentv2', {
        analytics_Storage: 'granted', ad_Storage: marketing ? 'granted' : 'denied'
      });
    }
    if(!set(IDS.ga4) || window.__grigGA) return; window.__grigGA = 1;
    var s = document.createElement('script'); s.async = 1;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + IDS.ga4;
    document.head.appendChild(s);
    gtag('js', new Date()); gtag('config', IDS.ga4);
  }
  function loadMarketing(){
    if(set(IDS.metaPixel) && !window.__grigFB){ window.__grigFB = 1;
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;
      s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', IDS.metaPixel); fbq('track','PageView');
    }
  }

  function apply(a, m){
    gtag('consent','update',{
      analytics_storage: a ? 'granted' : 'denied',
      ad_storage:        m ? 'granted' : 'denied',
      ad_user_data:      m ? 'granted' : 'denied',
      ad_personalization:m ? 'granted' : 'denied'
    });
    /* Shopify vlastní měření a aplikační pixely se řídí tímhle, ne naším gtagem */
    try {
      if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], function(err){
          if (err || !Shopify.customerPrivacy) return;
          Shopify.customerPrivacy.setTrackingConsent(
            {analytics: !!a, marketing: !!m, preferences: !!a, sale_of_data: !!m},
            function(){}
          );
        });
      }
    } catch(e){}
    if (a) loadAnalytics(m);
    else if (window.__grigClarity && window.clarity) {
      window.clarity('consent', false);
      window.clarity('consentv2', {analytics_Storage:'denied', ad_Storage:'denied'});
    }
    if (m) loadMarketing();
  }

  function load(){
    try { var o = JSON.parse(localStorage.getItem(KEY));
      if (!o || !o.t || (Date.now() - o.t) > MAXAGE) return null; return o;
    } catch(e){ return null; }
  }
  function save(a, m){
    try { localStorage.setItem(KEY, JSON.stringify({a:!!a, m:!!m, t:Date.now()})); } catch(e){}
    apply(a, m);
  }

  var box = $('#consent'), opts = $('#ckOptions'), btnSave = $('#ckSave'), btnCust = $('#ckCustomise');
  var btnConsentClose = $('#ckClose');
  function preferences(expanded){
    if (!box) return;
    box.classList.toggle('grig-consent-expanded', expanded);
    box.setAttribute('role', expanded ? 'dialog' : 'region');
    if (expanded) box.setAttribute('aria-modal', 'true');
    else box.removeAttribute('aria-modal');
    if (opts) opts.style.display = expanded ? 'block' : 'none';
    if (btnSave) btnSave.style.display = expanded ? 'block' : 'none';
    if (btnCust) {
      btnCust.style.display = expanded ? 'none' : 'block';
      btnCust.setAttribute('aria-expanded', String(expanded));
    }
    if (btnConsentClose) btnConsentClose.hidden = !expanded;
  }
  /* Clear the inline display:none so grig.css lays out the bar or the preferences card. */
  function show(){ if(box) box.style.display = ''; }
  function hide(){ if(box) box.style.display = 'none'; preferences(false); }
  function openPreferences(){
    var s = load(), cA = $('#ck-analytics'), cM = $('#ck-marketing');
    if (cA) cA.checked = !!(s && s.a);
    if (cM) cM.checked = !!(s && s.m);
    preferences(true);
    show();
  }
  function closePreferences(){
    // Discard unsaved choices. First visitors return to the nonmodal notice.
    if (load()) hide();
    else preferences(false);
  }

  var saved = load();
  if (saved) { apply(saved.a, saved.m); } else { show(); }

  if (box) {
    var cA = $('#ck-analytics'), cM = $('#ck-marketing');
    $('#ckAccept').onclick = function(){ save(true, true); hide(); };
    $('#ckReject').onclick = function(){ save(false, false); hide(); };
    if (btnCust) btnCust.onclick = openPreferences;
    if (btnConsentClose) btnConsentClose.onclick = closePreferences;
    if (btnSave) btnSave.onclick = function(){
      save(cA && cA.checked, cM && cM.checked); hide();
    };
  }
  var reopen = $('#ckReopen');
  if (reopen) reopen.onclick = function(ev){
    ev.preventDefault();
    openPreferences();
  };

  window.trackAddToCartItems = function(payload, requested, source){
    var consent = load();
    if (!consent || (!consent.a && !consent.m)) return;
    var rows = window.GRIGMerch ? GRIGMerch.analyticsItems(payload, requested) : [];
    if (!rows.length) return;
    var value = rows.reduce(function(sum,item){ return sum + item.price * item.quantity; },0);
    value = Math.round(value * 100) / 100;
    if (consent.a) {
      dataLayer.push({ecommerce:null});
      dataLayer.push({event:'add_to_cart', ecommerce:{currency:CUR,value:value,items:rows},grig_source:source});
    }
    if (consent.m && window.fbq) fbq('track','AddToCart',{
      content_ids:rows.map(function(item){return item.item_variant;}),content_type:'product',
      contents:rows.map(function(item){return {id:item.item_variant,quantity:item.quantity,item_price:item.price};}),
      value:value,currency:CUR
    });
  };

  /* GRIG_AOV_ANALYTICS_BEGIN: interaction events, never another ecommerce add. */
  document.addEventListener('grig:offer-interaction', function(event){
    var consent=load(), detail=event.detail || {};
    var currentTheme=window.Shopify && window.Shopify.theme;
    // Private theme tests must not become production performance data.
    if(!currentTheme || currentTheme.role!=='main' || !consent || !consent.a)return;
    if(!['impression','click','add','upgrade','goal_reached','goal_lost'].includes(detail.event))return;
    if(!['home','collection','pdp','mix','drawer','cart'].includes(detail.surface))return;
    if(typeof detail.kind!=='string' || !/^[a-z][a-z0-9_]{0,40}$/.test(detail.kind))return;
    if(!['EUR','CZK'].includes(detail.currency))return;
    var ids=detail.variantIds, quantities=detail.quantities;
    if(!Array.isArray(ids) || !Array.isArray(quantities) || ids.length!==quantities.length || ids.length>12)return;
    if(ids.some(function(id){return typeof id!=='string' || !/^[0-9]{1,18}$/.test(id);}))return;
    if(quantities.some(function(q){return !Number.isSafeInteger(q) || q<1;}))return;
    if(!Number.isSafeInteger(detail.valueCents) || detail.valueCents<0)return;
    var data={offer_surface:detail.surface,offer_kind:detail.kind,variant_ids:ids.join(','),
      quantities:quantities.join(','),offer_amount:detail.valueCents/100,currency:detail.currency};
    if(Number.isSafeInteger(detail.threshold) && detail.threshold>=0 && ['sachets','cents'].includes(detail.thresholdUnit)){
      data.threshold=detail.threshold;data.threshold_unit=detail.thresholdUnit;
    }
    if(typeof detail.contextProductId==='string' && /^[0-9]{1,18}$/.test(detail.contextProductId))data.context_product_id=detail.contextProductId;
    gtag('event','aov_offer_'+detail.event,data);
  });
  /* GRIG_AOV_ANALYTICS_END */

  var giftCompletions = new Set();
  try { JSON.parse(sessionStorage.getItem('grig_gift_completions') || '[]').forEach(function(key){giftCompletions.add(key);}); } catch (_) {}
  document.addEventListener('grig:gift-result', function(event){
    var consent=load(), detail=event.detail || {};
    if (!consent || !consent.a || detail.trigger!=='submit') return;
    var allowed={occasion:['christmas','birthday','secret_santa','party','just_because'],
      recipient:['partner','family','colleague','friend','group'],appetite:['variety','easy','all'],recommendation:['trio','dare','range']};
    if (!Object.keys(allowed).every(function(key){return allowed[key].includes(detail[key]);})) return;
    var values={occasion:detail.occasion,recipient:detail.recipient,appetite:detail.appetite,recommendation:detail.recommendation};
    var signature=Object.values(values).join('|');
    if(giftCompletions.has(signature))return;
    giftCompletions.add(signature);
    try { sessionStorage.setItem('grig_gift_completions',JSON.stringify(Array.from(giftCompletions))); } catch (_) {}
    gtag('event','gift_finder_complete',values);
  });

    /* hamburger */
  var hbg = document.getElementById('hamburger');
  var mob = document.getElementById('mobileMenu');
  if (hbg && mob) {
    hbg.addEventListener('click', function() {
      var open = mob.classList.toggle('open');
      hbg.classList.toggle('open', open);
      hbg.setAttribute('aria-expanded', open);
    });
    mob.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        mob.classList.remove('open');
        hbg.classList.remove('open');
        hbg.setAttribute('aria-expanded', false);
      });
    });
  }
  var closeBtn = document.getElementById('mobileClose');
if (closeBtn) {
  closeBtn.addEventListener('click', function() {
    mob.classList.remove('open');
    hbg.classList.remove('open');
    hbg.setAttribute('aria-expanded', false);
  });
}


})();

/* Reserve page space only for visible cookie controls, without changing consent. */
(function(){
  var box = document.getElementById('consent');
  if (!box) return;
  var bar = document.getElementById('grig-sticky-atc'), pending = 0, lastOffset = -1;
  function measure(){
    pending = 0;
    var rect = box.getBoundingClientRect(), style = getComputedStyle(box);
    var visible = !box.hidden && style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0;
    /* Distance from a full-width notice's top edge to the viewport bottom: the sticky bar rests on it.
       The floating desktop preferences card does not lift anything. */
    var fullWidth = rect.left <= 1 && rect.right >= document.documentElement.clientWidth - 1;
    var offset = visible && fullWidth ? Math.ceil(Math.max(0, innerHeight - rect.top)) : 0;
    var barHeight = bar ? Math.ceil(bar.getBoundingClientRect().height) : 0;
    /* Sticky plus notice stay within a quarter of the screen, otherwise the sticky waits for the cookie choice.
       The preferences view is modal, so the sticky hides behind it. */
    var tall = visible && !!bar && (box.classList.contains('grig-consent-expanded') || offset + barHeight > innerHeight * 0.25);
    document.body.style.setProperty('--grig-consent-offset', offset + 'px');
    document.body.classList.toggle('grig-consent-visible', visible);
    document.body.classList.toggle('grig-consent-tall', tall);
    if (offset !== lastOffset) {
      lastOffset = offset;
      document.dispatchEvent(new CustomEvent('grig:consent-offset', {detail: offset}));
    }
  }
  function queue(){ if (!pending) pending = requestAnimationFrame(measure); }
  if ('ResizeObserver' in window) {
    var resizeObserver = new ResizeObserver(queue);
    resizeObserver.observe(box);
    if (bar) resizeObserver.observe(bar);
  }
  if ('MutationObserver' in window) {
    var mutationObserver = new MutationObserver(queue);
    mutationObserver.observe(box, {attributes:true,subtree:true,attributeFilter:['style','class','hidden']});
    if (bar) mutationObserver.observe(bar, {attributes:true,attributeFilter:['class']});
  }
  document.addEventListener('click', function(event){
    var reopen = document.getElementById('ckReopen');
    if (box.contains(event.target) || (reopen && reopen.contains(event.target))) queue();
  }, true);
  addEventListener('resize', queue, {passive:true});
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', queue, {passive:true});
    window.visualViewport.addEventListener('scroll', queue, {passive:true});
  }
  if (document.fonts) document.fonts.ready.then(queue);
  measure();
})();

